import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/set-d2c.png'
import _imports_1 from '@/assets/image/set-b2b.png'


const _withScopeId = n => (_pushScopeId("data-v-5cc1e04d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-info" }
const _hoisted_2 = { class: "order-title" }
const _hoisted_3 = {
  key: 0,
  class: "order-address mb_10"
}
const _hoisted_4 = { class: "order-item-item" }
const _hoisted_5 = { class: "order-item-item" }
const _hoisted_6 = { class: "order-item-item" }
const _hoisted_7 = { style: {"width":"200px"} }
const _hoisted_8 = { class: "delivery" }
const _hoisted_9 = { class: "order-item-item" }
const _hoisted_10 = { class: "order-item-item" }
const _hoisted_11 = { class: "order-item-item" }
const _hoisted_12 = { class: "order-item-item" }
const _hoisted_13 = { class: "order-item-item" }
const _hoisted_14 = { class: "order-item-item" }
const _hoisted_15 = { class: "order-item-item" }
const _hoisted_16 = { class: "order-item-item" }
const _hoisted_17 = { class: "order-item-item" }
const _hoisted_18 = { class: "order-item-item" }
const _hoisted_19 = { class: "order-item-item" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "address-setting" }
const _hoisted_22 = {
  key: 1,
  class: "order-address mb_10"
}
const _hoisted_23 = { class: "order-item-item" }
const _hoisted_24 = { class: "order-item-item" }
const _hoisted_25 = { class: "order-item-item" }
const _hoisted_26 = { class: "order-item-item" }
const _hoisted_27 = { class: "order-title flex-bwn" }
const _hoisted_28 = { class: "order-address mb_10" }
const _hoisted_29 = { class: "order-item flex-ter" }
const _hoisted_30 = { style: {"width":"400px"} }
const _hoisted_31 = { style: {"flex":"1"} }
const _hoisted_32 = { class: "order-item flex-ter" }
const _hoisted_33 = { style: {"width":"400px"} }
const _hoisted_34 = { style: {"width":"400px"} }
const _hoisted_35 = { class: "order-title flex-bwn" }
const _hoisted_36 = { class: "order-address mb_10" }
const _hoisted_37 = { class: "order-item flex-ter" }
const _hoisted_38 = { style: {"width":"300px"} }
const _hoisted_39 = { style: {"width":"300px"} }
const _hoisted_40 = { style: {"width":"300px"} }
const _hoisted_41 = {
  key: 3,
  class: "flex-center-bwn switch"
}
const _hoisted_42 = { class: "order-title" }
const _hoisted_43 = { class: "mb_10" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { key: 3 }
const _hoisted_48 = { class: "line--2" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { key: 3 }
const _hoisted_54 = { style: {"width":"200px"} }
const _hoisted_55 = { class: "line--2" }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { key: 2 }
const _hoisted_61 = { class: "flex-ter" }
const _hoisted_62 = { class: "flex-ter" }
const _hoisted_63 = {
  key: 1,
  class: "flex-ter"
}
const _hoisted_64 = { class: "product-tag" }
const _hoisted_65 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_0,
  style: {"margin-left":"10px","width":"30px"},
  class: "order-tag"
}
const _hoisted_66 = {
  key: 1,
  referrerPolicy: "no-referrer",
  src: _imports_1,
  style: {"margin-left":"10px","width":"30px"},
  class: "order-tag"
}
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 2 }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_70 = { key: 0 }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { key: 2 }
const _hoisted_73 = { class: "flex-ter" }
const _hoisted_74 = { class: "order-title" }
const _hoisted_75 = { class: "mb_10" }
const _hoisted_76 = {
  key: 0,
  class: "flag-btn"
}
const _hoisted_77 = {
  key: 0,
  class: "flag-btn"
}
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "flex-col" }

import { t } from '@/plugins/i18n'
import { countryCodeNameMap } from '@/common/const'
import { ref, reactive, onActivated, toRaw, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import dayjs from 'dayjs'
import { Calendar, QuestionFilled } from '@element-plus/icons-vue'
import STable from '@/components/Table/index.vue'
import AppLink from '@/components/common/AppLink.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import ProductStats from '../components/ProductStats.vue'
import AddressDialog from './AddressDialog.vue'
import FeeDialog from './FeeDialog.vue'
import B2bFeeDialog from './B2bFeeDialog.vue'
import CombinationDialog from '../components/CombinationDialog.vue'
import { getPlatformOrderDetail, getB2bPlatformOrderDetail, getBillingFeeDetails, updateSynLogisticsNoApi, updateOrderSynLogisticsNoApi, getOrderEditAddressApi, configDeliveryIntercept, getOrderDetailFundListApi } from '@/apis/order'
import GoodsLink from '@/components/common/GoodsLink.vue'
import Guide from '@/components/guide/index.vue'
import { getTrack } from '@/apis/inShipping'
import TrackDialog from '@/views/inshipping/ShippingList/TrackDialog/index.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import confirmDialog from '@/components/common/ConfirmDialog'
import FeeDetail from './FeeDetail.vue'
import FeeDetailDialog from '@/views/inshipping/ShippingInfo/components/FeeDetail.vue'
import FinalPriceDialog from '../components/FinalPriceDialog.vue'
import { getJapanTime, getTrueNumber } from '@/util/common'
import {
  d2cShoppingColumns1,
  b2bShoppingColumns,
  columns,
  childColumns,
  tableConfig,
  d2cShoppingColumns1NEW,
  b2bShoppingColumnsNEW
} from './data'
import { getArea } from '@/apis/shopcart'
import { isD2C, useRtfix, isJA, isKO, useSite, isMultiStore } from '@/store'
import { productStatsEnum, setProdcutLink } from '../data'
import { combinationStatusDict } from '../OrderList/data'
import ProductSku from '../components/ProductSku.vue'
import axios from 'axios'
import { useStore } from 'vuex'
import { exportFileDownload } from '@/util/useExport'
import { ElMessage, ElMessageBox } from 'element-plus'
import useRules, { useRule } from '@/util/useRules'
import { getOrderFundDetailApi } from '@/apis/fund'
import { montageAddition } from '@/util/calcAdt'
import { showCurrentUnit, showPriceAndUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
onActivated(() => {
  fundDetail.value = {}
  getOrder()
})
/** 获取图片 */
const getImage = (value: string) => {
  return value?.split(',')?.[0]
}

const orderInfo: any = reactive({
  orderType: null,
  platformOrder: null,
  platformOrderDeliverAddressDTO: null,
  platformOrderItemList: [],
  invoiceDetailsList: [],
  orderDetails: null,
  orderSettlementFeeDetails: null
})

const combinationVisible = ref(false)
const rowItem = ref()
const openCombinationVisible = (row: any) => {
  rowItem.value = toRaw(row)
  combinationVisible.value = true
}

const productChannel = ref(0) // 商品渠道 1市场购 2透明购
const fundDetail = ref({})
const fundLoading = ref(false)

const getColumns = (_columns: any) => {
  // 过滤韩国仓字段
  const filterKoreaColumns = _columns.filter((v: { isMultiStore: boolean }) => isMultiStore() || !v.isMultiStore)
  return filterKoreaColumns
}

const getOrder = () => {
  fundLoading.value = true
  const api: any = isD2C() ? getPlatformOrderDetail : getB2bPlatformOrderDetail
  api({
    platformOrderId: route.params.id
  }).then((res: any) => {
    if (res.success) {
      const {
        platformOrder,
        platformOrderDeliverAddressDTO,
        platformOrderItemList,
        invoiceDetailsList,
        orderDetails,
        orderSettlementFeeDetails,
        orderType,
        platformOrderDeliveryAdditionalList,
        stageInfos
      } = res.data
      orderInfo.stageInfos = stageInfos === '-' ? [] : stageInfos
      orderInfo.orderType = orderType
      orderInfo.platformOrder = platformOrder
      orderInfo.platformOrderDeliverAddressDTO = platformOrderDeliverAddressDTO
      orderInfo.platformOrderItemList = platformOrderItemList
      productChannel.value = platformOrderItemList[0].channel
      orderInfo.invoiceDetailsList = Array.isArray(invoiceDetailsList) ? invoiceDetailsList.filter((v: any) => {
        return v.deliveryStatus === 4 || v.deliveryStatus === 5
      }) : []
      orderInfo.orderDetails = orderDetails
      orderInfo.orderSettlementFeeDetails = orderSettlementFeeDetails
      orderInfo.platformOrderDeliveryAdditionalList = platformOrderDeliveryAdditionalList
      orderInfo.platformOrderNo = isD2C() ? platformOrder?.platformOrderNo : orderDetails.platformOrderNo
      if (isD2C()) {
        getIsCanEditAddress(platformOrder.platformOrderNo)
      }
      // 获取资金明细
      getOrderDetailFundListApi({
        platformOrderNo: orderInfo.platformOrderNo
      }).then((result: any) => {
        if (result.success) {
          // 附加项总和
          result.data.totalAdditionAmount = (result.data.additionSettlementGoodsDetailRespDTOS || []).reduce((total: number, v: any): number => {
            return total + v.settleMoney
          }, 0)
          result.data.additionSettlementGoodsDetailRespDTOSList = margeAddition(result.data.additionSettlementGoodsDetailRespDTOS || [])
          // 商品附加项(返品不可不良品)
          result.data.totalAbnormalAdditionAmount = (result.data.additionSettlementGoodsDetailBadRespDTOS || []).reduce((total: number, v: any): number => {
            return total + v.settleMoney
          }, 0)
          result.data.additionSettlementGoodsDetailBadRespDTOSList = margeAddition(result.data.additionSettlementGoodsDetailBadRespDTOS || [])
          const purchasingFee = result.data.purchasingFee || []
          result.data.purchasingFeeList = {
            // 既成品采购
            3: {
              name: t('既成品采购费'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 3))
            },
            // 市场商品采购费：
            4: {
              name: t('市场商品采购费'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 4))
            },
            // 次品重买：
            6: {
              name: t('次品重买1'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 6))
            },
            // 次品退货
            5: {
              name: t('次品退货2'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 5))
            },
            // 商品组合
            10: {
              name: t('商品组合'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 10))
            },
            // 入库费
            31: {
              name: t('入库费'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 31))
            },
            7: {
              name: t('OEM批量生产'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 7))
            },
            8: {
              name: t('OEM样品订单'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 8))
            },
            68: {
              name: t('组合返工'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 68))
            },
            88: {
              name: t('关税报销'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 88))
            },
            89: {
              name: t('国际运费'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 89))
            }
          }
          if (isD2C()) {
            result.data.purchasingFeeList[32] = {
              name: t('出库费'),
              list: margePrice(purchasingFee.filter((i: any) => i.additionCode === 32))
            }
          }
          const feeList = Object.values(result.data.purchasingFeeList)
          const haveList: any = []
          const noList: any = []
          feeList.forEach((item: any) => {
            if (item.list?.length > 0) {
              haveList.push(item)
            } else {
              noList.push(item)
            }
          })
          result.data.purchasingFeeList = [
            ...haveList,
            ...noList
          ]
          console.log('result', result)
          fundDetail.value = result?.data ?? {}
          fundLoading.value = false
        }
      })
      // 获取
      orderInfo.invoiceDetailsList.forEach((item: any) => {
        if (!item.deliveryTaskCode) return
        getOrderFundDetailApi({
          deliverOrderNo: item.deliveryTaskCode
        }).then((res: any) => {
          if (res.success) {
            item.deliveryFee = res.data.totalAmount
          }
        })
      })
    }
  })
}

const margeAddition = (additionList: any) => {
  const addition: any = {}
  additionList.forEach((i: any) => {
    if (addition[i.additionCode]) {
      addition[i.additionCode].list = margePrice([
        ...addition[i.additionCode].list,
        i
      ])
    } else {
      addition[i.additionCode] = {
        name: i.additionNameJp,
        list: [
          {
            ...i
          }
        ]
      }
    }
  })
  return addition
}
const margePrice = (list: any) => {
  if (!list) return []
  const l: any = []
  list.forEach((i: any) => {
    let isHave = false
    l.forEach((t: any) => {
      if (t.settlePrice === i.settlePrice) {
        isHave = true
        t.num += i.num
        t.settleMoney = computePrice(t.settleMoney + i.settleMoney)
      }
    })
    if (!isHave) {
      l.push(i)
    }
  })
  return l
}

const computePrice = (price: number) => {
  return Math.round(price * 100) / 100
}
const store = useStore()
const exportLoading = ref(false)
const exportPdf = () => {
  exportLoading.value = true
  axios({
    method: 'GET',
    url: process.env.VUE_APP_URL + '/order/customer/platformOrder/exportQingQiuShu',
    responseType: 'blob',
    headers: {
      'X-AuthShopId': store.getters.curShop,
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    },
    params: {
      platformOrderNo: orderInfo?.orderDetails.platformOrderNo
    }
  }).then(res => {
    exportFileDownload(res, { type: 'application/pdf', name: t('领收书') })
  }).finally(() => {
    exportLoading.value = false
  })
}

const addressVisible = ref(false)
const feeVisible = ref(false)
const FeeInfoList = ref([])

const showFeeInfo = (data: never[]) => {
  FeeInfoList.value = data
  feeVisible.value = true
}

const b2bFeeVisible = ref(false)
const provinces = ref()
getArea({ type: 0 }).then((res) => {
  provinces.value = res.data
})
const getAreaTxt = (row: { province: any }) => {
  const t: any = (provinces.value || []).find((e: any) => e.intAreaId === row.province)
  return t?.label
}

const getCityTxt = (row: { province: any; city: any }) => {
  const t: any = (provinces.value || []).find((e: any) => e.intAreaId === row.province)
  if (t) {
    const v = t.children.find((e: { intAreaId: any }) => e.intAreaId === row.city)
    return v?.label
  } else {
    return ''
  }
}

const trackVisible = ref(false)
const trackInfo: any = ref({})
const showTrack = (row: any) => {
  getTrack({
    deliveryTaskCode: row.deliveryTaskCode,
    logisticsCode: row.logisticsCode
  }).then((res: any) => {
    trackInfo.value = res.data
  }).finally(() => {
    trackVisible.value = true
  })
}
const changeSwitch = () => {
  if (orderInfo.platformOrder?.platformOrderStatus.some((v: any) => { return (v === '16' || v === '32') })) {
    return
  }
  if (orderInfo.platformOrder?.isSynLogisticsNo === 0) {
    // 开启
    changeStatus()
    return
  }
  ElMessageBox.confirm(t('关闭后将不再向您店铺同步物流单号及订单状态'), t('关闭提醒'), {
    confirmButtonText: t('确定'),
    cancelButtonText: t('取消'),
    type: 'warning',
    dangerouslyUseHTMLString: true
  }).then(() => {
    changeStatus()
  })
}
const changeStatus = () => {
  updateOrderSynLogisticsNoApi({
    platformOrderId: orderInfo.platformOrder.platformOrderId,
    newStatus: orderInfo.platformOrder?.isSynLogisticsNo === 1 ? 0 : 1
  }).then(() => {
    getOrder()
  })
}

// 是否可以修改
const isCanEditAddress = ref(true)
const getIsCanEditAddress = (platformOrderNo: any) => {
  getOrderEditAddressApi({
    platformOrderNo: platformOrderNo
  }).then((res: any) => {
    isCanEditAddress.value = res.data
  })
}

// 拦截
const interceptVisible = ref(false)
const interceptLoading = ref(false)
const interceptForm = ref({
  radioType: '0',
  interceptTime: ''
})
// const radioType = ref('0')
// const interceptTime = ref('')
const rules = computed(() => {
  return {
    radioType: [
      { required: true, message: t('必填'), trigger: 'change' }
    ],
    interceptTime: [
      { required: interceptForm.value.radioType === '2', message: t('必填'), trigger: 'change' }
    ]
  }
})
const disableDate = (current: Date) => {
  const today = parseInt((new Date().getTime() / 1000).toString())
  const zeroTime = today - (today % 86400) - 3600 * 8
  const currentTime = parseInt((current.getTime() / 1000).toString())
  return zeroTime > currentTime
}
const disableHour = () => {
  const hour = new Date().getHours() + 1
  const disabledHour = Array.from({ length: hour }, (v, k) => k)
  // 不是今天可以不限制小时
  const isToday = dayjs(new Date()).format('YYYY-MM-DD') === dayjs(interceptForm.value.interceptTime).format('YYYY-MM-DD')
  return isToday ? disabledHour : []
}
const setIntercept = () => {
  interceptForm.value.radioType = '0'
  interceptForm.value.interceptTime = ''
  interceptVisible.value = true
}
const submit = () => {
  if (interceptForm.value.radioType === '0') {
    return ElMessage.warning(t('请选择解除方式'))
  }
  if (interceptForm.value.radioType === '2' && !interceptForm.value.interceptTime) {
    return ElMessage.warning(t('请选择时间'))
  }
  interceptLoading.value = true
  const params = {
    platformOrderNo: orderInfo.platformOrder?.platformOrderNo,
    interceptFlag: 1,
    interceptCancelType: interceptForm.value.radioType,
    interceptCancelTime: interceptForm.value.radioType === '2' ? interceptForm.value.interceptTime : undefined
  }
  configDeliveryIntercept(params).then((res: any) => {
    if (!res.success) {
      return
    }
    interceptVisible.value = false
    getOrder()
  }).finally(() => {
    interceptLoading.value = false
  })
}
const closeInterceptIcon = require('@/assets/image/icon/exclamation@2x.png')
const closeIntercept = () => {
  const params = {
    platformOrderNo: orderInfo.platformOrder?.platformOrderNo,
    interceptFlag: 2
  }
  configDeliveryIntercept(params).then((res: any) => {
    if (!res.success) {
      return
    }
    interceptVisible.value = false
    getOrder()
  })
  // confirmDialog({
  //   // title: '出荷保留不可',
  //   title: `<div class='flex-ter'><img src=${closeInterceptIcon} style='width: 16px;height: 16px;margin-right:4px' /><span>出荷保留不可</span></div>`,
  //   text: '既に出荷済み状態の商品は出荷保留にできません',
  //   htmlNode: true
  // }).then(() => {
  //   console.log('submit')

  // }).catch(() => {
  //   console.log('cancel')
  // })
}
// 精确到小时
watch(() => { return interceptForm.value.interceptTime }, (e) => {
  // 如果他先选择今天之后的时间再选时间再选回今天 会绕过小时的限制
  // isToday时如果选择的小时e.getHours()早于现在就赋值为最近能选的小时
  const isToday = dayjs(new Date()).format('YYYY-MM-DD') === dayjs(e).format('YYYY-MM-DD')
  const targetHour = new Date(e).getHours()
  const newHour = new Date().getHours()
  let time = ''
  if (isToday && !(newHour < targetHour)) {
    time = dayjs(e).hour(newHour + 1).format('YYYY-MM-DD HH')
  } else {
    time = dayjs(e).format('YYYY-MM-DD HH')
  }
  // interceptForm.value.interceptTime = time.slice(0, -2) + '00'
  interceptForm.value.interceptTime = time
})

const deliverOrderNo = ref('')
const feeDetailVisible = ref(false)
const openFeeDetail = (row: any) => {
  deliverOrderNo.value = row.deliveryTaskCode
  feeDetailVisible.value = true
}

const finalData = ref([])
const finalStatus = ref(false)
const checkFinalPrice = (row: any) => {
  finalData.value = row.settlePriceList
  finalStatus.value = true
}
const currentUnit = computed(() => {
  if (isD2C()) {
    return showCurrentUnit(orderInfo.platformOrder?.deliveryCountry === COUNTRY.KR)
  }
  return showCurrentUnit(orderInfo.platformOrderItemList?.[0]?.goodsCountry === COUNTRY.KR)
})
const getAveragePrice = (row: any) => {
  if (row.settlePriceList?.length > 1 && (row.productType !== 3)) {
    let price = getTrueNumber(row.settlePriceList.reduce((total: number, v: any): number => {
      return total + v.price
    }, 0) / row.orderQuantity)
    if (row?.goodsCountry === COUNTRY.KR) {
      price = Math.ceil(price)
    }
    return showPriceAndUnit(price, currentUnit.value)
  }
  const price = row.settlePriceList?.[0]?.price
  const num = row.settlePriceList?.[0]?.num
  if (price && row.productType !== 3) {
    let p = getTrueNumber(price / num)
    if (row?.goodsCountry === COUNTRY.KR) {
      p = Math.ceil(p)
    }
    return showPriceAndUnit(p, currentUnit.value)
  }
  return '-'
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isD2C)())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('订单详情')), 1),
          (_unref(orderInfo).orderType === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_row, { class: "order-item flex-ter" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('THE CKB订单编号')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrder?.platformOrderNo), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('客户订单编号')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrder?.customerOrderNo), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('发货附加项')) + "：", 1),
                          (_unref(orderInfo).platformOrderDeliveryAdditionalList && _unref(orderInfo).platformOrderDeliveryAdditionalList.length > 0)
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                effect: "light",
                                placement: "top"
                              }, {
                                content: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("span", null, _toDisplayString(_unref(orderInfo).platformOrderDeliveryAdditionalList.map((v) => v?.additionNameJp).join(',')), 1)
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(orderInfo).platformOrderDeliveryAdditionalList.map((v) => {
                    return v.additionNameJp
                  }).join(',')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('下单时间')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrder?.createTime &&
                _unref(getJapanTime)(_unref(orderInfo).platformOrder.createTime)), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('收件人')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrderDeliverAddressDTO?.receiveName), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('电话')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrderDeliverAddressDTO?.receiveTel), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('邮编')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrderDeliverAddressDTO?.postalCode), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('国家')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrderDeliverAddressDTO?.country === '+81' ||
                _unref(orderInfo).platformOrderDeliverAddressDTO?.country === '2279' ? (_unref(isJA)() ? _unref(t)('日本') : 'Japan') :
                _unref(orderInfo).platformOrderDeliverAddressDTO?.countryJp), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('都道府県')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrderDeliverAddressDTO.provinceJp ||
                getAreaTxt(_unref(orderInfo).platformOrderDeliverAddressDTO || {})), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('市区町村')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrderDeliverAddressDTO.cityJp ||
                getCityTxt(_unref(orderInfo).platformOrderDeliverAddressDTO || {})), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('详情地址')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrderDeliverAddressDTO?.address), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    (_unref(isKO)())
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 0,
                          span: 6
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", null, _toDisplayString(_unref(t)('个人通关码')) + "：", 1),
                              _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrderDeliverAddressDTO?.clearanceCode), 1)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('发货地')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(countryCodeNameMap).get(_unref(orderInfo).platformOrder?.deliveryCountry)), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 18 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('拦截状态')) + "：", 1),
                          (_unref(orderInfo).platformOrder?.interceptFlag !== 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('未設定')), 1),
                                _createVNode(_component_el_button, {
                                  onClick: setIntercept,
                                  class: _normalizeClass({ interceptBtn: true, disAbledInterceptBtn: _unref(orderInfo).platformOrder?.platformOrderStatus[0] === '32' }),
                                  disabled: _unref(orderInfo).platformOrder?.platformOrderStatus[0] === '32'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('开启拦截')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["class", "disabled"])
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('保留中')), 1),
                                (_unref(orderInfo).platformOrder?.interceptCancelType === 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(t)('({time}に保留を自動解除)', {
                  time:
                    _unref(getJapanTime)(_unref(orderInfo).platformOrder?.interceptCancelTime, 'YYYY-MM-DD HH:mm')
                })), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_button, {
                                  class: "interceptBtn flex-cen-ter",
                                  onClick: closeIntercept
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('关闭拦截')), 1)
                                  ]),
                                  _: 1
                                })
                              ], 64))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!isCanEditAddress.value)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      effect: "dark",
                      content: _unref(t)('抱歉，订单正在打包中，不允许修改地址'),
                      placement: "top-end"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (addressVisible.value = true)),
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('编辑地址')), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "primary",
                      class: "address-setting edit-address-btn",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (addressVisible.value = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('编辑地址')), 1)
                      ]),
                      _: 1
                    }))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_el_row, { class: "order-item flex-ter" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 7 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('THE CKB订单编号')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrder?.platformOrderNo), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('客户订单编号')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrder?.customerOrderNo), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('下单时间')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(orderInfo).platformOrder?.createTime &&
                _unref(getJapanTime)(_unref(orderInfo).platformOrder.createTime)), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('发货地')) + "：", 1),
                          _createTextVNode(_toDisplayString(_unref(countryCodeNameMap).get(_unref(orderInfo).platformOrder?.deliveryCountry)), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
        ], 64))
      : _createCommentVNode("", true),
    (!_unref(isD2C)())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)('订单详情')), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(t)('THE CKB订单编号')) + "：" + _toDisplayString(_unref(orderInfo).orderDetails?.platformOrderNo), 1),
              _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(t)('订单标题')) + "：" + _toDisplayString(_unref(orderInfo).orderDetails?.customerOrderNo), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(t)('下单时间')) + "：" + _toDisplayString(_unref(orderInfo).orderDetails?.createTime &&
            _unref(getJapanTime)(_unref(orderInfo).orderDetails.createTime)), 1),
              _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(t)('发货地')) + "：" + _toDisplayString(_unref(countryCodeNameMap).get(_unref(orderInfo).platformOrderItemList?.[0]?.goodsCountry)), 1)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (false && !_unref(isD2C)())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)('订单结算费用详情')), 1)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("p", _hoisted_38, _toDisplayString(_unref(t)('商品代金')) + "：" + _toDisplayString(_unref(orderInfo).orderDetails?.platformOrderSettleStatus > 2 ?
              _unref(orderInfo).orderSettlementFeeDetails?.productCash
              ?? 0 : '-'), 1),
              _createElementVNode("p", _hoisted_39, _toDisplayString(_unref(t)('手续费')) + "：" + _toDisplayString(_unref(orderInfo).orderSettlementFeeDetails?.handlingFee ?? 0), 1),
              _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(t)('商品附加项')) + "：" + _toDisplayString(_unref(orderInfo).orderSettlementFeeDetails?.productAdditionalItems ?? 0), 1),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-left":"20px"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (b2bFeeVisible.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('明细')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(route).query.type)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", null, _toDisplayString(_unref(t)('追跡番号自動反映')), 1),
          _createVNode(_component_el_switch, {
            "model-value": !!_unref(orderInfo).platformOrder?.isSynLogisticsNo,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (changeSwitch(_ctx.row))),
            disabled: _unref(orderInfo).platformOrder?.platformOrderStatus.some((v) => { return (v == '16' || v == '32') })
          }, null, 8, ["model-value", "disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(FeeDetail, {
      loading: fundLoading.value,
      info: fundDetail.value,
      stageInfos: _unref(orderInfo).stageInfos,
      products: _unref(orderInfo).platformOrderItemList,
      countryCode: _unref(isD2C)() ? _unref(orderInfo).platformOrder?.deliveryCountry : _unref(orderInfo).platformOrderItemList?.[0]?.goodsCountry,
      currencyCode: _unref(isD2C)() ? _unref(orderInfo).platformOrder?.currencyCode : _unref(orderInfo).platformOrderItemList?.[0]?.currencyCode
    }, null, 8, ["loading", "info", "stageInfos", "products", "countryCode", "currencyCode"]),
    _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)('商品信息')), 1),
    _createElementVNode("div", _hoisted_43, [
      (_unref(orderInfo)?.platformOrderItemList.length > 0)
        ? (_openBlock(), _createBlock(STable, {
            key: 0,
            class: "productTable",
            tableData: _unref(orderInfo).platformOrderItemList,
            columns: getColumns(_unref(isD2C)() ? (_unref(d2cShoppingColumns1)) : _unref(b2bShoppingColumns)),
            tableConfig: _unref(tableConfig),
            onRowClick: _cache[7] || (_cache[7] = (row) => row.productType !== 3 && _ctx.$router.push(_unref(useRtfix)('ProductInfo', { query: { platformOrderItemId: row.platformOrderItemId, productType: row.productType } }))),
            showPagination: false
          }, {
            settleStatus: _withCtx(({ row }) => [
              (row.virtualFlag)
                ? (_openBlock(), _createElementBlock("span", _hoisted_44, " - "))
                : ([1, 2].includes(row.settleStatus))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_unref(t)('未结算')), 1))
                  : (row.settleStatus === 3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_unref(t)('已结算')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_47, "-"))
            ]),
            goodsCountry: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(countryCodeNameMap).get(row.goodsCountry)), 1)
            ]),
            actualProductSellPrice: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualProductSellPrice, _unref(currentUnit))), 1)
            ]),
            actualTotalProductSellPrice: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualTotalProductSellPrice, _unref(currentUnit))), 1)
            ]),
            platformOrderItemAdditionDTOList: _withCtx(({ row }) => [
              (row.platformOrderItemAdditionDTOList && row.platformOrderItemAdditionDTOList !== '-')
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    effect: "light",
                    placement: "top"
                  }, {
                    content: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionDTOList)), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionDTOList)), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createElementBlock("span", _hoisted_49, "-"))
            ]),
            purchasingFee: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.purchasingFee === '-' ? row.stallHandlingFee : row.purchasingFee, _unref(currentUnit))), 1)
            ]),
            domesticShipping: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.domesticShipping, _unref(currentUnit))), 1)
            ]),
            storageFee: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.storageFee, _unref(currentUnit))), 1)
            ]),
            deliverStorageFee: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.deliverStorageFee, _unref(currentUnit))), 1)
            ]),
            additionalFee: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.additionalFee, _unref(currentUnit))), 1)
            ]),
            expand: _withCtx(({ scope: scopeChild }) => [
              _createVNode(STable, {
                class: "combinationTable",
                "table-data": scopeChild.row.combinationOrderItemList,
                columns: getColumns(_unref(isD2C)() ? _unref(d2cShoppingColumns1NEW) : _unref(b2bShoppingColumnsNEW)),
                tableConfig: _unref(tableConfig),
                showPagination: false
              }, {
                settleStatus: _withCtx(({ row }) => [
                  (row.virtualFlag)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, " - "))
                    : ([1, 2].includes(row.settleStatus))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_unref(t)('未结算')), 1))
                      : (row.settleStatus === 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_unref(t)('已结算')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_53, "-"))
                ]),
                goodsCountry: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(countryCodeNameMap).get(row.goodsCountry)), 1)
                ]),
                actualProductSellPrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualProductSellPrice, _unref(currentUnit))), 1)
                ]),
                actualTotalProductSellPrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualTotalProductSellPrice, _unref(currentUnit))), 1)
                ]),
                domesticShipping: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.domesticShipping, _unref(currentUnit))), 1)
                ]),
                storageFee: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.storageFee, _unref(currentUnit))), 1)
                ]),
                deliverStorageFee: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.deliverStorageFee, _unref(currentUnit))), 1)
                ]),
                additionalFee: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.additionalFee, _unref(currentUnit))), 1)
                ]),
                purchasingFee: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.purchasingFee === '-' ? row.stallHandlingFee : row.purchasingFee, _unref(currentUnit)
                )), 1)
                ]),
                platformOrderItemAdditionDTOList: _withCtx(({ row }) => [
                  (row.platformOrderItemAdditionDTOList && row.platformOrderItemAdditionDTOList !== '-')
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "light",
                        placement: "top"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_54, _toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionDTOList)), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionDTOList)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createElementBlock("span", _hoisted_56, "-"))
                ]),
                shoppingInfo: _withCtx(({ row }) => [
                  _createElementVNode("div", {
                    class: "flex-ter",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createVNode(GoodsLink, {
                      goods: row,
                      class: "fx-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ShoppingPreview, {
                          image: getImage(row.productSkuImg || row.productMainImg || ''),
                          name: row.productTitleJp || ''
                        }, null, 8, ["image", "name"])
                      ]),
                      _: 2
                    }, 1032, ["goods"])
                  ])
                ]),
                productSku: _withCtx(({ row }) => [
                  row
                    ? (_openBlock(), _createBlock(ProductSku, {
                        key: 0,
                        row: row,
                        productType: row.productType,
                        isGroup: scopeChild.row.productType === 3
                      }, null, 8, ["row", "productType", "isGroup"]))
                    : _createCommentVNode("", true)
                ]),
                shoppingStats: _withCtx(({ row }) => [
                  (row.virtualFlag)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_57, " - "))
                    : row
                      ? (_openBlock(), _createBlock(ProductStats, {
                          key: 1,
                          row: row
                        }, null, 8, ["row"]))
                      : _createCommentVNode("", true)
                ]),
                feeInfo: _withCtx(() => [
                  _createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$router.push(_unref(useRtfix)('StoreFund', { query: { platformOrderNo: _unref(orderInfo).platformOrder?.platformOrderNo, currencyCode: _unref(orderInfo).platformOrder?.currencyCode } }))), ["stop"]))
                  }, _toDisplayString(_unref(t)('查看')), 1)
                ]),
                final: _withCtx(({ row }) => [
                  (row.settlePriceList?.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList.reduce((total, v): number => {
                  return total + v.price
                }, 0), _unref(currentUnit))), 1))
                    : _createCommentVNode("", true),
                  (row.settlePriceList?.length > 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: _withModifiers(($event: any) => (checkFinalPrice(row)), ["stop"]),
                        style: {"color":"#1890FF","cursor":"pointer"}
                      }, _toDisplayString(_unref(t)('查看详情')), 9, _hoisted_59))
                    : (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList?.[0]?.price ? row.settlePriceList?.[0]?.price : '-',
                _unref(currentUnit))), 1))
                ]),
                finalHead: _withCtx(() => [
                  _createElementVNode("div", _hoisted_61, _toDisplayString(_unref(t)('最终采购价')), 1)
                ]),
                averagePrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(getAveragePrice(row)), 1)
                ]),
                _: 2
              }, 1032, ["table-data", "columns", "tableConfig"])
            ]),
            shoppingInfo: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_62, [
                (row.productType !== 3)
                  ? (_openBlock(), _createBlock(GoodsLink, {
                      key: 0,
                      goods: row
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ShoppingPreview, {
                          image: getImage(row.productSkuImg || row.productMainImg || ''),
                          name: row.productTitleJp || ''
                        }, null, 8, ["image", "name"])
                      ]),
                      _: 2
                    }, 1032, ["goods"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createVNode(ShoppingPreview, {
                        image: getImage(row.productSkuImg || row.productMainImg || '')
                      }, null, 8, ["image"]),
                      _createElementVNode("p", null, _toDisplayString(row.productTitleJp), 1)
                    ])),
                _createElementVNode("div", _hoisted_64, [
                  (row.productType === 3 && _unref(isD2C)())
                    ? (_openBlock(), _createElementBlock("img", _hoisted_65))
                    : _createCommentVNode("", true),
                  (row.productType === 3 && !_unref(isD2C)())
                    ? (_openBlock(), _createElementBlock("img", _hoisted_66))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            productSku: _withCtx(({ row }) => [
              row
                ? (_openBlock(), _createBlock(ProductSku, {
                    key: 0,
                    row: row
                  }, null, 8, ["row"]))
                : _createCommentVNode("", true)
            ]),
            shoppingStats: _withCtx(({ row }) => [
              (row.virtualFlag)
                ? (_openBlock(), _createElementBlock("span", _hoisted_67, " - "))
                : (row.productType === 3 && _unref(orderInfo).orderType !== 1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "text",
                      onClick: _withModifiers(($event: any) => (openCombinationVisible(row)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(combinationStatusDict)[row.combinationStatus]), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (row.productType === 3 && _unref(orderInfo).orderType === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_unref(combinationStatusDict)[row.combinationStatus]), 1))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        row
                          ? (_openBlock(), _createBlock(ProductStats, {
                              key: 0,
                              row: row
                            }, null, 8, ["row"]))
                          : _createCommentVNode("", true)
                      ], 64))
            ]),
            feeInfo: _withCtx(() => [
              _createElementVNode("a", {
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$router.push(_unref(useRtfix)('StoreFund', { query: { platformOrderNo: _unref(orderInfo).platformOrder?.platformOrderNo, currencyCode: _unref(orderInfo).platformOrder?.currencyCode } }))), ["stop"]))
              }, _toDisplayString(_unref(t)('查看')), 1)
            ]),
            final: _withCtx(({ row }) => [
              (row.productType === 3)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_69
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (row.settlePriceList?.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList.reduce((total, v): number => {
                return total + v.price
              }, 0), _unref(currentUnit))), 1))
                      : _createCommentVNode("", true),
                    (row.settlePriceList?.length > 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: _withModifiers(($event: any) => (checkFinalPrice(row)), ["stop"]),
                          style: {"color":"#1890FF","cursor":"pointer"}
                        }, _toDisplayString(_unref(t)('查看详情')), 9, _hoisted_71))
                      : (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList?.[0]?.price ? row.settlePriceList?.[0]?.price : '-'
              , _unref(currentUnit))), 1))
                  ], 64))
            ]),
            finalHead: _withCtx(() => [
              _createElementVNode("div", _hoisted_73, _toDisplayString(_unref(t)('最终采购价')), 1)
            ]),
            averagePrice: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(getAveragePrice(row)), 1)
            ]),
            _: 1
          }, 8, ["tableData", "columns", "tableConfig"]))
        : _createCommentVNode("", true)
    ]),
    (_unref(orderInfo).invoiceDetailsList.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createElementVNode("div", _hoisted_74, _toDisplayString(_unref(t)('发货单详情')), 1),
          _createElementVNode("div", _hoisted_75, [
            _createVNode(STable, {
              tableData: _unref(orderInfo).invoiceDetailsList,
              columns: _unref(columns),
              tableConfig: { showExpand: true, rowKey: 'deliveryTaskCode' },
              "show-pagination": false
            }, {
              freightFee: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString(row.freightFee) + " " + _toDisplayString(_unref(currentUnit)), 1)
              ]),
              additionalFee: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString(row.additionalFee) + " " + _toDisplayString(_unref(currentUnit)), 1)
              ]),
              deliveryTaskCode: _withCtx(({ row }) => [
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(row.deliveryTaskCode) + " ", 1),
                  _createVNode(_component_el_tooltip, {
                    content: _unref(t)('由于该订单商品无法在一个包裹中装下，我们为您拆成了多个包裹进行发货'),
                    placement: "top",
                    effect: "light"
                  }, {
                    default: _withCtx(() => [
                      (row.splitFlag === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_unref(t)('拆')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["content"]),
                  (row.preferFlag === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(_unref(t)('优')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              logisticsCode: _withCtx(({ row }) => [
                _createElementVNode("a", {
                  onClick: ($event: any) => (showTrack(row))
                }, _toDisplayString(row.logisticsCode), 9, _hoisted_78)
              ]),
              expand: _withCtx(({ scope }) => [
                _createVNode(STable, {
                  tableData: scope.row.productDetailsList,
                  columns: _unref(childColumns),
                  showPagination: false,
                  tableConfig: { showHandler: true }
                }, {
                  actualProductSellPrice: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row.actualProductSellPrice) + " " + _toDisplayString(_unref(currentUnit)), 1)
                  ]),
                  actualTotalProductSellPrice: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row.actualTotalProductSellPrice) + " " + _toDisplayString(_unref(currentUnit)), 1)
                  ]),
                  shoppingInfo: _withCtx(({ row }) => [
                    _createVNode(ShoppingPreview, {
                      image: getImage(row.productSkuImg || row.productMainImg || ''),
                      name: row.productTitleJp || '',
                      url: _unref(setProdcutLink)(row)
                    }, null, 8, ["image", "name", "url"])
                  ]),
                  productPropertiesName: _withCtx(({ row }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                      return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                    }), 128))
                  ]),
                  orderItemStatus: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(productStatsEnum)[row.orderItemStatus]), 1)
                  ]),
                  shoppingStats: _withCtx(({ row }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.shoppingStats, (item) => {
                      return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
                    }), 128))
                  ]),
                  otherFee: _withCtx(({ row }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.otherFee, (item) => {
                      return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["tableData", "columns"])
              ]),
              createTime: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
              ]),
              deliveryTime: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.deliveryTime)), 1)
              ]),
              deliveryStatus: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.deliveryStatus === 5 ? _unref(t)('已发货') : _unref(t)('未发货')), 1)
              ]),
              deliveryFee: _withCtx(({ row }) => [
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(row.deliveryFee) + _toDisplayString(_unref(currentUnit)) + " ", 1),
                  _createElementVNode("a", {
                    onClick: ($event: any) => (openFeeDetail(row))
                  }, _toDisplayString(_unref(t)('详情')), 9, _hoisted_79)
                ])
              ]),
              _: 1
            }, 8, ["tableData", "columns"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(AddressDialog, {
      visible: addressVisible.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((addressVisible).value = $event)),
      title: _unref(t)('编辑收货地址'),
      form: _unref(orderInfo)?.platformOrderDeliverAddressDTO || {},
      provinces: provinces.value,
      onSuccess: getOrder,
      platformOrderNo: _unref(orderInfo)?.platformOrder?.platformOrderNo,
      isMultiStore: _unref(orderInfo)?.platformOrderItemList?.[0]?.goodsCountry === _unref(COUNTRY).KR
    }, null, 8, ["visible", "title", "form", "provinces", "platformOrderNo", "isMultiStore"]),
    _createVNode(FeeDialog, {
      title: _unref(t)('费用详情'),
      visible: feeVisible.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((feeVisible).value = $event)),
      table: FeeInfoList.value
    }, null, 8, ["title", "visible", "table"]),
    _createVNode(CombinationDialog, {
      visible: combinationVisible.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((combinationVisible).value = $event)),
      rowItem: rowItem.value
    }, null, 8, ["visible", "rowItem"]),
    _createVNode(B2bFeeDialog, {
      visible: b2bFeeVisible.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((b2bFeeVisible).value = $event)),
      rowItem: { platformOrderId: _unref(route).params.id, platformOrderNo: _unref(orderInfo).orderDetails?.platformOrderNo }
    }, null, 8, ["visible", "rowItem"]),
    _createVNode(TrackDialog, {
      visible: trackVisible.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((trackVisible).value = $event)),
      rowItem: trackInfo.value
    }, null, 8, ["visible", "rowItem"]),
    _createVNode(CommonDialog, {
      visible: interceptVisible.value,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((interceptVisible).value = $event)),
      "show-close": false,
      width: '500px',
      title: _unref(t)('是否拦截'),
      footer: true,
      className: 'interceptDialog',
      onOk: submit,
      onCancel: _cache[17] || (_cache[17] = ($event: any) => (interceptVisible.value = false)),
      loading: interceptLoading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
          },
          model: interceptForm.value,
          "label-width": "172px",
          rules: _unref(rules),
          style: {"margin":"30px 0"},
          "validate-on-rule-change": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('出荷保留解除方式'),
              prop: "radioType"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_80, [
                  _createVNode(_component_el_radio, {
                    modelValue: interceptForm.value.radioType,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((interceptForm.value.radioType) = $event)),
                    label: "1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('手動解除')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_radio, {
                    modelValue: interceptForm.value.radioType,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((interceptForm.value.radioType) = $event)),
                    label: "2",
                    class: _normalizeClass(_unref(useSite)() + '-radio')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('指定時間に自動解除（手動で早期解除可能）')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "class"])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('解除時間'),
              prop: "interceptTime"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  ref: (_value, _refs) => {
                    _refs['interceptTimePicker'] = _value
                  },
                  modelValue: interceptForm.value.interceptTime,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((interceptForm.value.interceptTime) = $event)),
                  type: "datetime",
                  placeholder: _unref(t)('请选择2'),
                  format: "YYYY-MM-DD HH",
                  "value-format": "YYYY-MM-DD HH",
                  "validate-event": false,
                  "popper-class": "interceptTimePicker",
                  "disabled-date": disableDate,
                  "disabled-hours": disableHour,
                  disabled: interceptForm.value.radioType === '1',
                  "prefix-icon": _unref(Calendar),
                  style: {"width":"290px"},
                  editable: false
                }, null, 8, ["modelValue", "placeholder", "disabled", "prefix-icon"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "title", "loading"]),
    _createVNode(FeeDetailDialog, {
      deliverOrderNo: deliverOrderNo.value,
      visible: feeDetailVisible.value,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((feeDetailVisible).value = $event)),
      currentUnit: _unref(currentUnit)
    }, null, 8, ["deliverOrderNo", "visible", "currentUnit"]),
    _createVNode(FinalPriceDialog, {
      visible: finalStatus.value,
      "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((finalStatus).value = $event)),
      finalData: finalData.value,
      currentUnit: _unref(currentUnit)
    }, null, 8, ["visible", "finalData", "currentUnit"])
  ]))
}
}

})